import React, { useState } from "react";
import {
  Typography,
  Button,
  IconButton,
  Divider,
  makeStyles
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import OptimizedTooltip from "./OptimizedTooltip";
import clsx from "clsx";
import { Skeleton } from "@material-ui/lab";
import SelectProjectPopover from "../accountDrawer/appsDialog/SelectProjectPopover";
import { MoveTo } from "../accountDrawer/appsDialog/appIcons";
import { store } from "../..";
import RefreshIcon from "@material-ui/icons/Refresh";

const useStyles = makeStyles(theme => ({
  selectedText: {
    display: "flex",
    alignItems: "center",
    "& > p": {
      fontWeight: 500,
      fontSize: "0.9375rem",
      lineHeight: "1.125rem",
      marginRight: theme.spacing(1.5)
    }
  },
  projectsSelectedText: {
    position: "absolute",
    bottom: 10,
    left: 24
  },
  textWithIcons: {
    bottom: 8
  },
  refreshBtn: {
    marginLeft: theme.spacing(0.5)
  },
  addBtn: {
    textTransform: "none",
    marginLeft: theme.spacing(1.5),
    boxShadow: "none",
    fontWeight: "normal",
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    "& svg": {
      color: "#fff",
      fontSize: "24px !important"
    },
    "&.Mui-disabled, &.Mui-disabled:hover": {
      backgroundColor: "#1329FE",
      color: "#fff",
      opacity: "38%"
    }
  }
}));

function DialogTopPanel({
  isApp,
  count,
  content,
  disabled,
  tooltipDelete,
  tooltipDownload,
  numSelected,
  setSelected,
  isProjectTable,
  itemsCount,
  handleOpen,
  currentAction,
  getDataPerPage,
  loading,
  iconClassName = "",
  dataAddCy = "",
  dataDeleteCy = "",
  handleMultipleDownload,
  handleMultipleDelete = () => {},
  handleAdd,
  setLoadingCircle,
  selected,
  addId,
  addButtonDisabled
}) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = e => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div
      className={clsx(classes.selectedText, {
        [classes.textWithIcons]: isProjectTable && !!numSelected,
        [classes.projectsSelectedText]: isProjectTable
      })}
    >
      {numSelected ? (
        <Typography id="dialogTopPanel-numberOfSelected">
          {numSelected} of {count} selected
        </Typography>
      ) : loading && !count ? (
        <Skeleton style={{ width: "70px", marginRight: "12px" }} />
      ) : (
        <Typography id="dialogTopPanel-itemCount">{itemsCount}</Typography>
      )}
      <Divider
        orientation="vertical"
        style={{ height: 20, marginRight: "4px" }}
      />
      {!!numSelected ? (
        <>
          {!isApp && (
            <OptimizedTooltip placement="bottom" title={tooltipDelete}>
              <span>
                <IconButton
                  onClick={handleMultipleDelete}
                  data-cy={dataDeleteCy}
                  className={iconClassName}
                  disabled={disabled}
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </OptimizedTooltip>
          )}
          {handleMultipleDownload && (
            <OptimizedTooltip placement="bottom" title={tooltipDownload}>
              <span>
                <IconButton
                  onClick={handleMultipleDownload}
                  className={iconClassName}
                  disabled={disabled}
                >
                  <SaveAltIcon />
                </IconButton>
              </span>
            </OptimizedTooltip>
          )}
          {isApp && (
            <Divider
              orientation="vertical"
              style={{ height: 20, margin: "0 4px" }}
            />
          )}
        </>
      ) : (
        handleAdd && (
          <Button
            id={addId}
            variant="contained"
            color="primary"
            className={classes.addBtn}
            disableElevation
            data-cy={dataAddCy}
            startIcon={<AddIcon />}
            onClick={() => {
              handleAdd();
            }}
            disabled={addButtonDisabled}
          >
            {content}
          </Button>
        )
      )}
      {isApp && (
        <>
          <IconButton
            disabled={loading}
            onClick={() => {
              getDataPerPage();
              setSelected([]);
            }}
            className={classes.refreshBtn}
          >
            <RefreshIcon />
          </IconButton>
          <Button
            variant="contained"
            color="primary"
            className={classes.addBtn}
            disableElevation
            data-cy={dataAddCy}
            startIcon={<MoveTo />}
            onClick={handleClick}
            disabled={!numSelected}
          >
            Move to
          </Button>
          <SelectProjectPopover
            selected={selected}
            setLoadingCircle={setLoadingCircle}
            currentAction={currentAction}
            setSelected={setSelected}
            handleClose={handleClose}
            anchorEl={anchorEl}
            handleOpen={handleOpen}
          />
        </>
      )}
    </div>
  );
}

export default DialogTopPanel;
